import GlobalRequest from './global-request';

const COMPANY_URL = 'v2/admin/companies';

export default class CompanyApi {
    static async getAllCompanies() {
        return await GlobalRequest.getRequest(COMPANY_URL);
    }
}
